<div [ngClass]="{'compound-field': true, 'centered': layoutObject?.centered, 'parent-is-compound-field': parentIsCompoundField, 'align-elements': hasFieldsWithAlignment}">

  <!-- default paragraph layout -->
  <ng-container *ngIf="!hasFieldsWithAlignment">
    <ng-template ngFor let-element [ngForOf]="layoutObject?.elements" let-last="last" let-first="first" [ngForTrackBy]="trackByIndex">
      <ng-container *ngTemplateOutlet="ParagraphElements; context: {element: element, last: last, first: first}"></ng-container>
    </ng-template>
  </ng-container>

  <!-- paragraph layout with field alignment -->
  <ng-container *ngIf="hasFieldsWithAlignment">
    <div #LeftElementWrapper class="lm-paragraph-element-wrapper left">
      <!-- elements that don't have an alignment directive are included in the elements array -->
      <ng-container *ngFor="let element of layoutObject.elements; last as last; first as first; trackBy: trackByIndex;">
        <ng-container *ngTemplateOutlet="ParagraphElements; context: {element: element, last: last, first: first}"></ng-container>
      </ng-container>
      <ng-container *ngFor="let element of layoutObject.leftElements; last as last; first as first; trackBy: trackByIndex;">
        <ng-container *ngTemplateOutlet="ParagraphElements; context: {element: element, last: last, first: first}"></ng-container>
      </ng-container>
    </div>

    <div #CenterElementWrapper class="lm-paragraph-element-wrapper center">
      <ng-container *ngFor="let element of layoutObject.centerElements; last as last; first as first; trackBy: trackByIndex;">
        <ng-container *ngTemplateOutlet="ParagraphElements; context: {element: element, last: last, first: first}"></ng-container>
      </ng-container>
    </div>

    <div #RightElementWrapper class="lm-paragraph-element-wrapper right">
      <ng-container *ngFor="let element of layoutObject.rightElements; last as last; first as first; trackBy: trackByIndex;">
        <ng-container *ngTemplateOutlet="ParagraphElements; context: {element: element, last: last, first: first}"></ng-container>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #ParagraphElements let-element=element let-last=last let-first=first>
    <ng-container [ngSwitch]="element.elementLayout">

      <ng-container *ngSwitchCase="layoutSubType.CHECK_CONTROL">
        <ng-template visiblewhen [layoutObject]="element.checkcontrol" [model]="model" [specFields]="specFields">
          <lm-checkcontrol *ngIf="!element.checkcontrol.cfgHidden"
                  #Element
                  [layoutObject]="element.checkcontrol"
                  [specFields]="specFields"
                  [placeHolder]="placeHolder"
                  [model]="model"
                  [layoutInfo]="layoutInfo"
                  [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
                  [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                  [ngClass]="{'last-member-element': last, 'first-member-element': first}"
                  (fieldEvent)="onFieldEvent($event)"
                  class="field"
          ></lm-checkcontrol>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="layoutSubType.CAPTCHA_CONTROL">
        <ng-template visiblewhen [layoutObject]="element.captchaControl" [model]="model" [specFields]="specFields">
          <lm-captcha-control [layoutObject]="element.captchaControl" [parentIsParagraph]="true"></lm-captcha-control>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="layoutSubType.BUTTON">
        <ng-template visiblewhen [layoutObject]="element.button" [model]="model" [specFields]="specFields">
          <lm-button *ngIf="!element.button.cfgHidden"
                  #Element
                  [layoutObject]="element.button"
                  [layoutInfo]="layoutInfo"
                  [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                  [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
                  [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
                  [specFields]="specFields"
                  [model]="model"
                  [ngClass]="{'last-member-element': last, 'first-member-element': first}"
                  (fieldEvent)="onFieldEvent($event)"
                  class="field"
          ></lm-button>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="layoutSubType.FIELD">
        <ng-template visiblewhen [layoutObject]="element.field" [model]="model" [specFields]="specFields">
          <lm-field *ngIf="!element.field.cfgHidden"
                    #Element
                    [layoutObject]="element.field"
                    [layoutInfo]="layoutInfo"
                    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
                    [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
                    [specFields]="specFields"
                    [placeHolder]="placeHolder"
                    [model]="model"
                    [ngClass]="{'last-member-element': last, 'first-member-element': first}"
                    (fieldEvent)="onFieldEvent($event)"
                    (errorOnMemberField)="onMemberFieldError($event)"
                    class="field"
          ></lm-field>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="layoutSubType.TEXT">
        <ng-template visiblewhen [layoutObject]="element.text" [model]="model" [specFields]="specFields">
          <lm-text
                  #Element
                  [layoutObject]="element.text"
                  [specFields]="specFields"
                  [placeHolder]="placeHolder"
                  [model]="model"
                  [layoutInfo]="layoutInfo"
                  [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                  [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
                  [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
                  [ngClass]="{'last-member-element': last, 'first-member-element': first}"
                  (fieldEvent)="onFieldEvent($event)"
                  (errorOnMemberField)="onMemberFieldError($event)"
                  class="field"
          ></lm-text>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="layoutSubType.MENU">
        <lm-simple-card
                [automationId]="element.menu.automationId"
                [type]="element.menu.type"
                [specFields]="specFields"
                [model]="model"
                [scale]="element.menu.menuScale"
                [link]="element.menu.link"
                [showBackground]="false"
                [imageUrl] = "element.menu.image"
                [title]="element.menu.label"
                [description]="element.menu.description"
                [paragraphLayout]="true"
                [isLink]="element.menu.isLink"
                [isExternalLink]="element.menu.external"
                [allowScannableSearch]="element.menu.allowScannableSearch"
                [openWhenSingleResult]="element.menu.openWhenSingleResult"
                class="field"
                [ngClass]="{'last-member-element': last, 'first-member-element': first}"
                (fieldEvent)="onFieldEvent($event)"
        ></lm-simple-card>
      </ng-container>

      <ng-container *ngSwitchCase="layoutSubType.MANUAL_REPRESENTATION">
       <lm-manual-representation style="width:100%"
            [manualRep]="element.manualrep"
            class="{{element.class}}"
            [model]="model"
           (fieldEvent)="onFieldEvent($event)"
        ></lm-manual-representation>
      </ng-container>
    </ng-container>
  </ng-template>
</div>
